import React from 'react';
import {Link} from 'react-router-dom';
import {Row, Col, Pagination, Grid} from 'react-bootstrap';
import Moment from 'react-moment';
import Spinner from './Spinner';

const spanStyle="hidden-md hidden-lg hidden-sm";

const Description =()=>{
  return(
    <Row className="title">
      <Col xs={12} className="text-center">
        <span className="main">
          コミュニティー
        </span>
        <span className="sub">
          EDGEに関して自由に質問したり、回答したりするコミュニティーです
        </span>
      </Col>
    </Row>
  );
};


const ForumTable = ({threads, query, handlers}) =>{
  let {onClickHandler, onAuthorSelect} = handlers;
  return(
    <Row className="forum-container">
      <Col xs={12} md={10} mdOffset={1}>
        <div className={threads.length===0?'empty-tb':'filled-tb'}>
          <table className="forum-table">
            <thead>
              <tr>
                <td className="hidden-xs number">番号</td>
                <td className="title">タイトル</td>
                <td className="hidden-xs views">ビュー</td>
                <td className="hidden-xs replies">回答数</td>
                <td className="hidden-xs date">日付</td>
              </tr>
            </thead>
            <tbody>
              {threads&&threads.map((thread, i)=>(
                <tr key={"thread_"+i} onClick={(evt)=>onClickHandler(thread.id, evt)} id={1}>
                  <td className="hidden-xs">{thread.num}</td>
                  <td className="title">
                    {thread.name}
                    <p className="description-box">
                      by {thread.author}
                      <span className={spanStyle}>| ビュー {thread.views}</span>
                      <span className={spanStyle}>| 回答数 {thread.comments} |</span>
                      <br/>
                      <Moment className={spanStyle} format="YYYY-MM-DD">
                        {thread.date}
                      </Moment>
                    </p>
                  </td>
                  <td className="hidden-xs">{thread.views}</td>
                  <td className="hidden-xs">{thread.comments}</td>
                  <td>
                    <Moment className="hidden-xs" format="YYYY-MM-DD">
                      {thread.date}
                    </Moment>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="bottom-btns">
          {/* <button className="btn" onClick={onAuthorSelect}> */}
            {/* {query.author?'私の投稿':'すべてのスレㅊド'} */}
            {/* {query.author?'私の投稿':'All Posts'} */}
          {/* </button> */}
          <Link to="/forum/new-post" className="btn">新しいスレッド</Link>
        </div>
      </Col>
    </Row>
  );
};

const Paginator=({page, handleSelect, pageLength, maxButtons})=>{

  return(
    <Row className="paging text-center">
      <Col xs={12}>
        <Pagination
          prev
          next
          ellipsis={false}
          boundaryLinks={true}
          items={pageLength}
          maxButtons={maxButtons}
          activePage={parseInt((page),10)}
          onSelect={handleSelect} />
      </Col>
    </Row>
  );
};

const Search=({handlers})=>{
  let {onSearchChange, onEnter, onSearchEnter} = handlers;
  return(
    <Row className="search text-center">
      <Col xs={12}>
        <div className="input-group">
          <input type="text" className="form-control"
            placeholder="search" onChange={onSearchChange}
            onKeyPress={onEnter}/>
          <button className="input-group-addon" onClick={onSearchEnter}>
            <span className="glyphicon glyphicon-search"/>
          </button>
        </div>
      </Col>
    </Row>
  );
}

// ************************************
// REFACTORING REQUIRED
// ***********************************

const ForumContainer=({state, handlers})=>{
  let {threads, page, pageLength, maxButtons, query} = state;
  return(
    <Grid className="forum-page">
      <Description />
      {threads?
        <ForumTable threads={threads} query={query} handlers={handlers} />:
        <Spinner />
      }
      <Paginator page={page} pageLength={pageLength}
        handleSelect={handlers.handleSelect} maxButtons={maxButtons}/>
      {/* <Search handlers={handlers} /> */}
      {/* <Row className="search text-center">
        <Col xs={12}>
          <div className="input-group">
            <input type="text" className="form-control"
              placeholder="search" onChange={handlers.onSearchChange}
              onKeyPress={handlers.onEnter}/>
            <button className="input-group-addon" onClick={handlers.onSearchEnter}>
              <span className="glyphicon glyphicon-search"/>
            </button>
          </div>
        </Col>
      </Row> */}
    </Grid>
  );
};

export default ForumContainer;



// WEBPACK FOOTER //
// ./src/components/Support.Forum.js